<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Facturas de Venta <a routerLink="/sales/invoice" class="clickeable"
				style="text-decoration: none;">
				<span class="sp-con-default">
					<i class="fa-solid fa-circle-plus"></i>
					<i style="color: var(--bs-bg-servicios);" class="bx bxs-shopping-bag sp-el-default"></i>
				</span>
				<span>
					Nueva Factura
				</span>
			</a>
		</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<div class="row" id="options-date">
					<div class="col-sm form-group">
						<label for="type" class="form-label">Ver resultados de </label>
						<select name="type" id="type" (change)="changeType()" [(ngModel)]="type" class="form-select">
							<option value="0">Hoy</option>
							<option value="1">Últimos 7 días</option>
							<option value="2">Este mes</option>
							<option value="3">El mes pasado</option>
							<option value="4">Últimos dos meses</option>
							<option value="5">Últimos tres meses</option>
							<option value="6">Intervalo de fecha</option>
						</select>
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="startDate" class="form-label">Fecha Inicio</label>
						<input type="date" id="startDate" [(ngModel)]="startDate"
							name="startDate" class="form-control">
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="endDate" class="form-label">Ver resultados de </label>
						<input type="date" id="endDate" max="{{todayDate | date:'yyyy-MM-dd'}}"
							[(ngModel)]="endDate" name="endDate" class="form-control">
					</div>
					<div class="col-auto form-group" *ngIf="type==6">
						<div class="h-100 row align-items-end">
							<button class="btn btn-success" (click)="changeDate()" [disabled]="loadingData">
								<span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingData"></span>
								<i class="fa fa-filter" *ngIf="!loadingData"></i>
							</button>
						</div>
					</div>
				</div>
				<div class="row" style="margin-top: 1em;" id="options-other-filters">
					<div class="col-sm">
						<span class="form-label">Tipo de documento</span>
						<div class="row row-cols-1 row-cols-md-3" style="padding: 1em;">
							<div class="col form-check">
								<input class="form-check-input" (change)="filtering()" [(ngModel)]="invoiceCheck"
									type="checkbox" value="" id="invoiceCheck">
								<label class="form-check-label" for="invoiceCheck">
									Factura
								</label>
							</div>
							<div class="col form-check">
								<input class="form-check-input" (change)="filtering()" [(ngModel)]="receiptCheck"
									type="checkbox" value="" id="receiptCheck">
								<label class="form-check-label" for="receiptCheck">
									Recibo
								</label>
							</div>
							<div class="col form-check">
								<input class="form-check-input" (change)="filtering()" [(ngModel)]="ncreCheck" type="checkbox"id="ncreCheck">
								<label class="form-check-label" for="ncreCheck">
									Nota de crédito
								</label>
							</div>
						</div>
					</div>
					<div class="col-sm form-group">
						<span class="form-label">Tipo de operación</span>
						<div class="row" style="padding: 1em;">
							<div class="col form-check">
								<input class="form-check-input" (change)="filtering()" [(ngModel)]="goodCheck"
									type="checkbox" value="" id="goodCheck">
								<label class="form-check-label" for="goodCheck">
									Bien
								</label>
							</div>
							<div class="col form-check">
								<input class="form-check-input" (change)="filtering()" [(ngModel)]="serviceCheck"
									type="checkbox" value="" id="serviceCheck">
								<label class="form-check-label" for="serviceCheck">
									Servicio
								</label>
							</div>
						</div>
					</div>
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Número o serie</label>
						<div class="input-group">
							<input type="text" id="filterVendors" [(ngModel)]="searchVendor"
								placeholder="Ingresa número o serie" name="filterVendors" class="form-control">
							<button class="btn btn-primary" (click)="filtering()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
					<div class="col-sm form-group">
						<label for="filterWarehouse" class="form-label">Bodega</label>
						<select name="filterWarehouse" [(ngModel)]="warehouseSelected" id="filterWarehouse"
							(change)="filtering()" class="form-select">
							<option value="-1">Todas</option>
							<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">{{warehouse.name}}
							</option>
						</select>
					</div>
					<div class="col-sm form-group">
						<label for="order" class="form-label">Orden </label>
						<select name="order" id="order" (change)="changeOrder()" [(ngModel)]="isAscendent"
							class="form-select">
							<option value="1">Ascendente</option>
							<option value="0">Descendente</option>
						</select>
						<span class="form-text">
							<i class="fa fa-circle-info"></i>
							<ng-container *ngIf="isAscendent==1">
								Los resultados se muestran de la fecha más lejana a la más reciente
							</ng-container>
							<ng-container *ngIf="isAscendent==0">
								Los resultados se muestran de la fecha más reciente a la más lejana
							</ng-container>
						</span>
					</div>
				</div>
				<div class="table-responsive" [class.table-responsive-without]="waitingFor && !seeingAnulate"
					style="margin-bottom: 0;">
					<table class="table table-striped" style="margin-bottom: 0;">
						<thead>
							<tr>
								<th class="ta th-balance" [class.balance-success]="total>=0" colspan="10">
									Total 
									<span *ngIf="!loadingData">{{total | currency:'Q'}}</span>
									<span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingData"></span>
								</th>
							</tr>
							<tr>
								<th class="ta">
									Serie
								</th>
								<th class="ta">
									Número
								</th>
								<th class="ta">
									Fecha Crea
								</th>
								<th class="ta">
									Fecha Cert
								</th>
								<th class="ta">
									Bodega
								</th>
								<th class="ta">
									NIT
								</th>
								<th class="ta">
									Cliente
								</th>
								<th class="ta">
									Total
								</th>
								<th class="ta">
									T/Pago
								</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="!loadingData">
								<ng-container *ngFor="let invoice of pagination.filter">
									<tr [class.canceled-invoice]="invoice.cancelled"
										[class.hide-all]="waitingFor?.id==invoice.id && !seeingAnulate">
										<td class="ta">
											{{invoice.series}}
										</td>
										<td class="ta">
											{{invoice.number}}
										</td>
										<td class="ta">
											{{convertToString(invoice.accountingDate)}}
										</td>
										<td class="ta">
											{{convertToString(invoice.date)}}
										</td>
										<td class="ta">
											{{invoice.warehouseData?.name || 'Sin bodega'}}
										</td>
										<td class="ta">
											{{invoice.nit}}
										</td>
										<td
											class="ta client-name"
											[class.long-name]="(invoice.clientData?.name?.length || 0) > 20">

											{{getFixedName(invoice.clientData?.name || invoice.name || '')}}
										</td>
										<td class="ta">
											<!-- {{(invoice.totalCost + invoice.totalExtraTax + invoice.totalTaxes + invoice.totalSubsidio) | currency : ((invoice.currency==1)?"$":"Q")}} -->
											 <ng-container *ngIf="!invoice.isNcre">
												{{
													(
													(invoice.totalCost || 0) +
													(invoice.totalExtraTax || 0) +
													(invoice.totalTaxes || 0)
													) | currency : ((invoice.currency == 1) ? '$' : 'Q')
												}}
												</ng-container>

												<ng-container *ngIf="invoice.isNcre">
												{{
													(invoice.total || 0)
													| currency : ((invoice.currency == 1) ? '$' : 'Q')
												}}
												</ng-container>
										</td>
										<td class="ta">
											<ng-container *ngIf="invoice.isNcre">
												—
											</ng-container>

											<ng-container *ngIf="!invoice.isNcre">
												{{invoice.methodPay == null ? 'DESCONOCIDO' : invoice.methodPay}}
											</ng-container>
										</td>
										<td class="ta">
											<div *ngIf="!invoice.isNcre" style="display: flex; justify-content: space-between;">
												<span class="clickeable text-info" title="Editar"
													(click)="editInvoice(invoice)" [appCheckPermission]="[2046]"
													[permissionType]="permissionType.UPDATE">
													<i class="fa fa-edit"></i>
												</span>
												<span class="clickeable text-danger" title="Anular"
													(click)="anulateInvoice(invoice)"><i class="fa fa-ban"
														[appCheckPermission]="[2046]"
														[permissionType]="permissionType.DELETE"></i></span>
												<div class="container-superposition" title="Eliminar"
													[appCheckPermission]="[2046]" [permissionType]="permissionType.DELETE">
													<div class="element-superposition"
														*ngIf="waitingFor?.id == invoice.id && !seeingAnulate">
														<span>¿Está seguro que desea eliminar esta factura?</span>
														<span class="a-container">
															<span class="a-hover" (click)="resetDeletingDiv()"><i
																	class="fa fa-ban"></i>NO</span>
															<span class="a-hover text-danger"><i class="fa fa-trash"
																	(click)="confirmDelete(invoice)"></i>SÍ</span>
														</span>
													</div>
													<span class="clickeable text-danger" (click)="deleteInvoice(invoice)">
														<i *ngIf="!deleting[invoice.id]" class="fa fa-trash"></i>
														<span *ngIf="deleting[invoice.id]"
															class="spinner-border spinner-border-sm"
															aria-hidden="true"></span>
													</span>
												</div>
												<span (click)="downloadInvoice(invoice)" title="Descargar"
													*ngIf="invoice.gfaceGenerated || invoice.downloadable"
													class="clickeable text-info" [appCheckPermission]="[2046]"
													[permissionType]="permissionType.READ">
													<i *ngIf="!loadingDownload[invoice.id]"
														class="fa-solid fa-download"></i>
													<span *ngIf="loadingDownload[invoice.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
												</span>
												<span (click)="performConversion(invoice)" title="Convertir"
													*ngIf="invoice.series === 'VALE'" class="clickeable text-info"
													[appCheckPermission]="[2046]" [permissionType]="permissionType.UPDATE">
													<i *ngIf="!loadingPerfom[invoice.id]"
														class="fa-solid fa-rotate-right"></i>
													<span *ngIf="loadingPerfom[invoice.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
												</span>
												<span (click)="detailingInvoice(invoice)" title="Ver"
													class="clickeable text-info" [appCheckPermission]="[2046]"
													[permissionType]="permissionType.READ">
													<i *ngIf="!detailing[invoice.id]" class="fa fa-eye"></i>
													<span *ngIf="detailing[invoice.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
												</span>
											</div>
											<span *ngIf="invoice.isNcre" class="text-muted">
												Sin acciones
											</span>
										</td>
									</tr>
								</ng-container>
							</ng-container>
							<tr class="tr-middle" *ngIf="loadingData">
								<td colspan="10">
								<app-loading-animation [height]="'5rem'"></app-loading-animation>
								<p class="display-6">Cargando...</p>
								</td>
							</tr>
							<tr *ngIf="pagination.filter.length == 0 && !loadingData">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>
									{{sales.length == 0?'No se encontraron ventas en las fechas seleccionadas':
									'No se encontraron resultados para el filtro aplicado'}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
	<app-modal-invoice-sale *ngIf="editing" [newSale]="newSale" [isCreating]="false"
		(close)="editing = false; newSale = null"></app-modal-invoice-sale>
	<div class="hide-background" *ngIf="waitingFor || invoiceDetail">
		<div class="for-click" (click)="resetDeletingDiv()"></div>
		<div class="modal" tabindex="-1" *ngIf="seeingAnulate">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h1>ANULACIÓN DE FACTURAS</h1>
						<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark"
								(click)="waitingFor =null; seeingAnulate = false"></i>
						</h1>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="reason" class="form-label">Razón de la anulación <span
									class="required">*</span></label>
							<textarea [(ngModel)]="cancelledDescription"
								placeholder="Ingresa una descripción para la factura a anular" name="reason" id="reason"
								cols="30" rows="10" class="form-control"></textarea>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-primary" (click)="waitingFor = null; seeingAnulate = false">
							<i class="fa fa-xmark"></i>CANCELAR</button>
						<button class="btn btn-warning" [disabled]="cancelledDescription==''"
							(click)="confirmCanceledInvoice()">
							<i *ngIf="!anulating" class="fa fa-ban"></i>
							<span *ngIf="anulating" class="spinner-border spinner-border-sm"
								aria-hidden="true"></span>ANULAR
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal" tabindex="-1" *ngIf="invoiceDetail">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h1>Detalles de Factura de Venta</h1>
					</div>
					<div class="modal-body">
						<p class="p-invoice" style="text-align: right;">Serie <b>{{invoiceDetail.series}}</b></p>
						<p class="p-invoice" style="text-align: right;">Número <b>{{invoiceDetail.number}}</b></p>
						<p class="p-invoice" style="text-align: right;">Guatemala <b>{{invoiceDetail['dateString']}}</b>
						</p>
						<p class="p-invoice">Nombre <b>{{invoiceDetail.name}}</b></p>
						<p class="p-invoice">Nit <b>{{invoiceDetail.nit}}</b></p>
						<div>
							<table class="table table-striped">
								<thead>
									<tr>
										<!-- Cantidad	Producto	Descripcion	Precio	Total -->
										<th class="td-center">
											Cantidad
										</th>
										<th>
											Producto
										</th>
										<th>

										</th>
										<th class="td-center">
											Precio
										</th>
										<th class="td-center">
											Total
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let product of invoiceDetail['detail']">
										<td class="td-center">{{product.quantity}}</td>
										<td>
											{{product.productData.name}}
											<div class="input-group input-group-sm"
												*ngIf="productToTransform && productToTransform.id == product.productData.id">
												<button class="btn btn-danger"
													(click)="resetTransform(product['input'])"><i
														class="fa fa-xmark"></i></button>
												<button class="btn btn-success" (click)="transform(product)"
													[disabled]="!product['input'].verified">
													<i *ngIf="!transforming" class="fa-solid fa-save"></i>
													<span *ngIf="transforming" class="spinner-border spinner-border-sm"
														aria-hidden="true"></span>
												</button>
												<app-input-autocomplete [inputs]="product['input']"
													(inputMethod)="writeProduct($event.event, product['input'])"
													[placeholder]="'Ingresa un producto'"
													(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - '+$event.filterElement.name"
													[filterElements]="product['input'].filterElements"
													(changeStatus)="selectProduct($event.filterElement, product['input'])"
													[allBorderRadius]="false" [custom]="true">
													<ng-template #itemsTemplate let-filter>
														<!-- This is the content that will be projected -->
														<div items>
															<p
																style="margin: 0; color: skyblue; font-size: 1.5em; font-weight: bolder;">
																{{filter.name}}</p>
															<p style="margin: 0; color: white; font-size: 0.8em;">
																Código: <b>{{filter.code}}</b></p>
														</div>
													</ng-template>
												</app-input-autocomplete>
											</div>
											<i class="fa-solid fa-arrows-rotate clickeable text-info"
												*ngIf="!productToTransform || productToTransform.id != product.productData.id"
												(click)="productToTransform = product.productData"></i>
										</td>
										<td class="td-center"></td>
										<td class="td-center">{{product.price+product.taxes + (product.extraTaxAmount) | currency : ((invoiceDetail.currency==1)?"$":"Q")}}</td>
										<td class="td-center">{{product.quantity * (product.price+product.taxes+product.extraTaxAmount) |
											currency
											: ((invoiceDetail.currency==1)?"$":"Q")}}</td>
									</tr>
								</tbody>
								<tfoot>
									<tr class="tr-middle">
										<td colspan="4">Total</td>
										<td colspan="4" class="td-center">{{invoiceDetail.totalCost +
											invoiceDetail.totalExtraTax +
											invoiceDetail.totalTaxes | currency : ((invoiceDetail.currency==1)?"$":"Q")}}
										</td>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-primary" (click)="invoiceDetail = null; seeingAnulate = false">
							<i class="fa fa-xmark"></i>CERRAR</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>